/**
 * MADAME KA — Popup Outubro Rosa
 * Aparece máximo 2x por dia na página inicial
 * Cupom: OUTUBROROSA (10% off)
 */

(function () {
  'use strict';

  var CFG = {
    delay_segundos: 5,
    cupom: 'OUTUBROROSA',
    storage_key: 'mk_popup_outubro_rosa',
    webhook_url: 'https://script.google.com/macros/s/AKfycbzH2IhX554ceoAViWmz0KrOvy-iIeVFRxraAQlFEKQ7zKKIJlANQBPE7RnhDHNt_MBa/exec',
    crm_url: 'https://madameka-crm.onrender.com/webhook/popup',
  };

  var path = window.location.pathname;
  if (!window.MK_POPUP_PREVIEW) {
    if (path !== '/' && path !== '/index' && path !== '/index.html') return;
  }

  // Laço rosa (SVG)
  var LACO = [
    '<svg class="mk-laco" viewBox="0 0 64 96" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">',
      '<defs>',
        '<linearGradient id="mkLacoA" x1="0" y1="0" x2="1" y2="1">',
          '<stop offset="0" stop-color="#f58bb0"/><stop offset="1" stop-color="#d63a72"/>',
        '</linearGradient>',
        '<linearGradient id="mkLacoB" x1="1" y1="0" x2="0" y2="1">',
          '<stop offset="0" stop-color="#f7a3c1"/><stop offset="1" stop-color="#e2558a"/>',
        '</linearGradient>',
      '</defs>',
      // fita de trás (desce para a direita)
      '<path d="M22 30 L48 86 L58 78 L34 30 Z" fill="#b92d61"/>',
      // laço superior
      '<path d="M32 6 C16 6 12 22 18 34 L24 46 L30 40 L25 30 C21 22 24 15 32 15 C40 15 43 22 39 30 L34 40 L40 46 L46 34 C52 22 48 6 32 6 Z" fill="url(#mkLacoA)"/>',
      // fita da frente (desce para a esquerda)
      '<path d="M40 30 L16 86 L6 78 L30 30 Z" fill="url(#mkLacoB)"/>',
      // brilho
      '<path d="M24 14 C20 18 19 24 21 30" stroke="#fff" stroke-opacity=".45" stroke-width="2" fill="none" stroke-linecap="round"/>',
    '</svg>'
  ].join('');

  function injectCSS() {
    var s = document.createElement('style');
    s.textContent = [
      '#mk-popup-overlay{position:fixed;inset:0;background:rgba(74,20,44,.5);z-index:99999;display:flex;align-items:center;justify-content:center;padding:16px;opacity:0;transition:opacity .3s;pointer-events:none}',
      '#mk-popup-overlay.mk-aberto{opacity:1;pointer-events:all}',
      '#mk-popup{background:#fff8fa;border-radius:18px;width:100%;max-width:420px;max-height:calc(100vh - 32px);overflow-y:auto;font-family:Georgia,serif;transform:translateY(20px) scale(.98);transition:transform .35s;box-shadow:0 20px 60px rgba(120,20,60,.25)}',
      '#mk-popup-overlay.mk-aberto #mk-popup{transform:translateY(0) scale(1)}',

      '#mk-popup-header{background:linear-gradient(160deg,#fde3ec 0%,#f9c6d8 100%);padding:26px 24px 22px;text-align:center;position:relative;border-bottom:1px solid #f2b3ca;overflow:hidden}',
      '#mk-popup-header:before,#mk-popup-header:after{content:"";position:absolute;border-radius:50%;background:rgba(255,255,255,.35)}',
      '#mk-popup-header:before{width:140px;height:140px;top:-60px;left:-50px}',
      '#mk-popup-header:after{width:100px;height:100px;bottom:-50px;right:-30px}',
      '#mk-popup-fechar{position:absolute;top:12px;right:14px;z-index:2;background:rgba(214,58,114,.15);border:none;width:30px;height:30px;border-radius:50%;color:#a52a5a;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;font-family:sans-serif;line-height:1}',
      '#mk-popup-fechar:hover{background:rgba(214,58,114,.25)}',
      '#mk-popup-header .mk-laco{width:46px;height:69px;display:block;margin:0 auto 10px;position:relative;z-index:1;filter:drop-shadow(0 4px 6px rgba(185,45,97,.3));animation:mkLacoPulse 2.8s ease-in-out infinite}',
      '@keyframes mkLacoPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.06)}}',
      '#mk-popup-header .mk-brand{position:relative;font-size:10px;letter-spacing:.25em;text-transform:uppercase;color:#b92d61;margin-bottom:6px;font-family:sans-serif}',
      '#mk-popup-header .mk-titulo{position:relative;font-size:32px;font-weight:400;color:#6b2140;line-height:1.1;font-style:italic}',
      '#mk-popup-header .mk-titulo b{font-weight:400;color:#d63a72}',
      '#mk-popup-header .mk-linha{position:relative;width:40px;height:1px;background:#d63a72;margin:12px auto;display:block}',
      '#mk-popup-header .mk-sub{position:relative;font-size:12.5px;color:#7d3a55;line-height:1.7;font-style:italic}',

      '#mk-popup-cupom-preview{background:#fdeef3;padding:11px 20px;display:flex;align-items:center;justify-content:center;gap:12px;border-bottom:1px solid #f2b3ca;flex-wrap:wrap}',
      '#mk-popup-cupom-preview .mk-cupom-txt{font-size:10px;color:#a52a5a;text-transform:uppercase;letter-spacing:.1em;font-family:sans-serif}',
      '#mk-popup-cupom-preview .mk-cupom-code{font-size:15px;font-weight:700;color:#6b2140;letter-spacing:.12em;background:#fff;padding:3px 12px;border-radius:4px;border:1px dashed #d63a72;font-family:sans-serif}',

      '#mk-popup-form{padding:18px 22px;background:#fff8fa}',
      '#mk-popup-form .mk-campo{margin-bottom:10px}',
      '#mk-popup-form .mk-campo label{display:block;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:#b92d61;margin-bottom:4px;font-family:sans-serif}',
      '#mk-popup-form .mk-campo input{width:100%;border:1px solid #f2c4d4;border-radius:6px;padding:9px 12px;font-size:14px;outline:none;transition:border-color .2s,box-shadow .2s;color:#4a1a2e;background:#fff;font-family:sans-serif;box-sizing:border-box}',
      '#mk-popup-form .mk-campo input:focus{border-color:#d63a72;box-shadow:0 0 0 3px rgba(214,58,114,.12)}',
      '#mk-popup-form .mk-campo input::placeholder{color:#d9a9bb}',
      '#mk-popup-erro{background:#fff5f5;border:1px solid #fecaca;border-radius:6px;padding:9px 12px;font-size:12px;color:#b91c1c;margin-bottom:10px;display:none;font-family:sans-serif}',
      '#mk-popup-btn{width:100%;background:#d63a72;color:#fff;border:none;border-radius:6px;padding:13px;font-size:12px;cursor:pointer;letter-spacing:.18em;text-transform:uppercase;font-family:sans-serif;transition:background .2s;margin-top:4px}',
      '#mk-popup-btn:hover{background:#b92d61}',
      '#mk-popup-btn:disabled{opacity:.6;cursor:not-allowed}',

      '#mk-popup-sucesso{display:none;padding:26px 24px;text-align:center;background:#fff8fa}',
      '#mk-popup-sucesso .mk-laco{width:38px;height:57px;display:block;margin:0 auto 10px}',
      '#mk-popup-sucesso .mk-ok-titulo{font-size:21px;font-weight:400;color:#6b2140;margin-bottom:6px;font-style:italic}',
      '#mk-popup-sucesso .mk-ok-linha{width:40px;height:1px;background:#d63a72;margin:10px auto;display:block}',
      '#mk-popup-sucesso .mk-ok-sub{font-size:13px;color:#7d3a55;margin-bottom:18px;line-height:1.6;font-style:italic}',
      '#mk-popup-sucesso .mk-ok-cupom{font-size:21px;font-weight:700;letter-spacing:.14em;color:#6b2140;background:#fdeef3;border:1.5px dashed #d63a72;border-radius:6px;padding:8px 20px;display:inline-block;margin-bottom:8px;font-family:sans-serif}',
      '#mk-popup-sucesso .mk-ok-hint{font-size:11px;color:#b92d61;letter-spacing:.05em;font-family:sans-serif}',
      '#mk-popup-copiar{margin-top:14px;width:100%;background:#d63a72;color:#fff;border:none;border-radius:6px;padding:12px;font-size:12px;cursor:pointer;letter-spacing:.15em;text-transform:uppercase;font-family:sans-serif;transition:background .2s}',
      '#mk-popup-copiar:hover{background:#b92d61}',
      '#mk-popup-fechar-sucesso{margin-top:10px;width:100%;background:transparent;border:1px solid #f2c4d4;border-radius:6px;padding:11px;font-size:12px;cursor:pointer;color:#7d3a55;font-family:sans-serif;letter-spacing:.1em;text-transform:uppercase;transition:border-color .2s}',
      '#mk-popup-fechar-sucesso:hover{border-color:#d63a72;color:#6b2140}',

      '#mk-popup-causa{margin:0 22px 14px;padding:10px 12px;background:#fdeef3;border-radius:8px;font-size:11px;color:#7d3a55;line-height:1.55;text-align:center;font-family:sans-serif}',
      '#mk-popup-causa b{color:#b92d61}',
      '#mk-popup-footer{padding:0 20px 14px;text-align:center;font-size:10px;color:#c98aa3;font-family:sans-serif;letter-spacing:.05em}',

      '@media(max-width:480px){',
        '#mk-popup-overlay{padding:20px 14px}',
        '#mk-popup{border-radius:14px}',
        '#mk-popup-header{padding:18px 18px 16px}',
        '#mk-popup-header .mk-laco{width:36px;height:54px;margin-bottom:6px}',
        '#mk-popup-header .mk-titulo{font-size:26px}',
        '#mk-popup-header .mk-sub{font-size:11.5px}',
        '#mk-popup-form{padding:14px 16px}',
        '#mk-popup-form .mk-campo input{padding:8px 10px;font-size:13px}',
        '#mk-popup-btn{padding:11px;font-size:11px}',
        '#mk-popup-causa{margin:0 16px 12px}',
      '}',
    ].join('');
    document.head.appendChild(s);
  }

  function criarHTML() {
    var overlay = document.createElement('div');
    overlay.id = 'mk-popup-overlay';
    overlay.innerHTML = [
      '<div id="mk-popup" role="dialog" aria-modal="true" aria-label="Outubro Rosa Madame Ka">',
        '<div id="mk-popup-header">',
          '<button id="mk-popup-fechar" aria-label="Fechar">&#x2715;</button>',
          LACO,
          '<div class="mk-brand">Madame Ka abra&#231;a a causa</div>',
          '<div class="mk-titulo">Outubro <b>Rosa</b></div>',
          '<span class="mk-linha"></span>',
          '<div class="mk-sub">Cuidar de si tamb&#233;m &#233; um ato de amor.<br>Fa&#231;a seu autoexame e incentive quem voc&#234; ama.</div>',
        '</div>',
        '<div id="mk-popup-cupom-preview">',
          '<span class="mk-cupom-txt">Seu cupom</span>',
          '<span class="mk-cupom-code">' + CFG.cupom + '</span>',
          '<span class="mk-cupom-txt">10% off</span>',
        '</div>',
        '<div id="mk-popup-form">',
          '<div class="mk-campo"><label>Nome</label><input type="text" id="mk-popup-nome" placeholder="Seu nome" autocomplete="given-name"></div>',
          '<div class="mk-campo"><label>WhatsApp</label><input type="tel" id="mk-popup-whatsapp" placeholder="(47) 99999-9999" autocomplete="tel"></div>',
          '<div class="mk-campo"><label>Email</label><input type="email" id="mk-popup-email" placeholder="seu@email.com" autocomplete="email"></div>',
          '<div id="mk-popup-erro">Preencha todos os campos corretamente.</div>',
          '<button id="mk-popup-btn" onclick="mkPopupEnviar()">Quero meu cupom rosa</button>',
        '</div>',
        '<div id="mk-popup-sucesso">',
          LACO,
          '<div class="mk-ok-titulo">Obrigada por se cuidar!</div>',
          '<span class="mk-ok-linha"></span>',
          '<div class="mk-ok-sub">Seu cupom do Outubro Rosa est&#225; pronto.<br>Use no checkout e ganhe 10% off.</div>',
          '<div class="mk-ok-cupom">' + CFG.cupom + '</div>',
          '<div class="mk-ok-hint">Cole no campo de cupom ao finalizar a compra</div>',
          '<button id="mk-popup-copiar" onclick="mkPopupCopiar()">Copiar cupom ' + CFG.cupom + '</button>',
          '<button id="mk-popup-fechar-sucesso" onclick="mkPopupFechar()">Continuar comprando</button>',
        '</div>',
        '<div id="mk-popup-causa">&#127872; <b>Lembrete de carinho:</b> o diagn&#243;stico precoce do c&#226;ncer de mama salva vidas. Agende seus exames.</div>',
        '<div id="mk-popup-footer">Madame Ka &middot; V&#225;lido durante o m&#234;s de outubro &middot; N&#227;o cumulativo</div>',
      '</div>',
    ].join('');
    document.body.appendChild(overlay);

    document.getElementById('mk-popup-fechar').addEventListener('click', mkPopupFechar);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) mkPopupFechar(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') mkPopupFechar(); });

    var wppInput = document.getElementById('mk-popup-whatsapp');
    wppInput.addEventListener('input', function () {
      var v = this.value.replace(/\D/g, '').slice(0, 11);
      if (v.length <= 10) { v = v.replace(/(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3'); }
      else { v = v.replace(/(\d{2})(\d{5})(\d{0,4})/, '($1) $2-$3'); }
      this.value = v;
    });
  }

  function lerContador() {
    var hoje = new Date().toLocaleDateString('pt-BR');
    var info;
    try { info = JSON.parse(localStorage.getItem(CFG.storage_key)) || null; } catch (e) { info = null; }
    if (!info || info.dia !== hoje) info = { count: 0, dia: hoje };
    return info;
  }

  function mkPopupAbrir() {
    if (!window.MK_POPUP_PREVIEW && lerContador().count >= 2) return;
    var overlay = document.getElementById('mk-popup-overlay');
    if (overlay) { overlay.classList.add('mk-aberto'); document.body.style.overflow = 'hidden'; }
  }

  window.mkPopupCopiar = function () {
    var btn = document.getElementById('mk-popup-copiar');
    function ok() {
      if (btn) {
        btn.textContent = '\u2713 Copiado!'; btn.style.background = '#2f8a5a';
        setTimeout(function () { btn.textContent = 'Copiar cupom ' + CFG.cupom; btn.style.background = '#d63a72'; }, 2500);
      }
    }
    if (navigator.clipboard) { navigator.clipboard.writeText(CFG.cupom).then(ok).catch(function () { fbCopy(CFG.cupom); ok(); }); }
    else { fbCopy(CFG.cupom); ok(); }
  };

  window.mkPopupFechar = function () {
    var overlay = document.getElementById('mk-popup-overlay');
    if (!overlay || !overlay.classList.contains('mk-aberto')) return; // só conta se estava aberto
    overlay.classList.remove('mk-aberto');
    document.body.style.overflow = '';
    var info = lerContador();
    info.count += 1;
    try { localStorage.setItem(CFG.storage_key, JSON.stringify(info)); } catch (e) {}
  };

  window.mkPopupEnviar = function () {
    var nome = document.getElementById('mk-popup-nome').value.trim();
    var whatsapp = document.getElementById('mk-popup-whatsapp').value.trim();
    var email = document.getElementById('mk-popup-email').value.trim();
    var erro = document.getElementById('mk-popup-erro');
    var btn = document.getElementById('mk-popup-btn');

    if (!nome || whatsapp.replace(/\D/g, '').length < 10 || email.indexOf('@') < 1) {
      erro.style.display = 'block'; return;
    }
    erro.style.display = 'none';
    btn.disabled = true;
    btn.textContent = 'Cadastrando...';

    var wpp = whatsapp.replace(/\D/g, '');
    var dados = {
      nome: nome, whatsapp: wpp, email: email, cupom: CFG.cupom,
      origem: window.location.href, data: new Date().toLocaleString('pt-BR'),
      segmento: 'Lead', campanha: 'Outubro Rosa'
    };

    if (CFG.webhook_url) { fetch(CFG.webhook_url, { method: 'POST', mode: 'no-cors', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(dados) }).catch(function () {}); }
    if (CFG.crm_url) { fetch(CFG.crm_url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ nome: nome, whatsapp: wpp, email: email }) }).catch(function () {}); }

    setTimeout(function () {
      document.getElementById('mk-popup-form').style.display = 'none';
      document.getElementById('mk-popup-cupom-preview').style.display = 'none';
      document.getElementById('mk-popup-sucesso').style.display = 'block';
    }, 800);
  };

  function fbCopy(txt) {
    var ta = document.createElement('textarea');
    ta.value = txt; ta.style.cssText = 'position:fixed;top:-9999px;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(ta);
  }

  function init() { injectCSS(); criarHTML(); setTimeout(mkPopupAbrir, (window.MK_POPUP_PREVIEW ? 0.3 : CFG.delay_segundos) * 1000); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

})();